import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-compras',
  templateUrl: './compras.component.html',
  styleUrls: ['./compras.component.scss']
})
export class ComprasComponent implements OnInit {

  lista = [];

  liquidacion: number;
  subtotal: number;
  flete = 0;
  descuento = 0;
  request = false;
  usuario: any;
  perfil: any;
  compra: any = {
    cliente: '',
    nombre: '',
    tipo: '',
    telefono: '',
    cedula: '',
    email: '',
    ciudad: '',
    direccion: '',
    total: '',
    subtotal: '',
    descuento: '',
    carrito: [],
    fecha: new Date().getTime(),
    refCompra: '',
    estado: 'Pendiente',
  };
  reference: number;
  public user = this.authSvc.afAuth.user;
  nombre: string;
  usrType: string;
  idUser: string;
  telefono: string;
  email: string;
  ciudEnvio: string;
  dirEnvio: string;
  descto: number;
  nomCliente: string;
  cedCliente: string;
  telCliene: string;
  correoCliente: string;
  distrib = false;
  constructor(private prodSvc: ProductosService,
              private authSvc: AuthService,
              private router: Router) {
this.loadStorage();
}

ngOnInit(): void {
  this.calcularCosto();
  this.loadUserStorage();
}

loadUserStorage(){
  if (localStorage.getItem('dataUserSupedido')) {
    this.distrib = true;
    this.usuario = JSON.parse( localStorage.getItem('dataUserSupedido'));
    this.perfil = JSON.parse( localStorage.getItem('dataUserSupedido'));
    this.descto = Number(this.perfil.descuento);        
    this.descto = Number(this.perfil.descuento);
    this.idUser = this.perfil.uid;
    this.nombre = this.perfil.nombre;
    this.usrType = this.perfil.tipo;
    this.telefono = this.perfil.telefono;
    this.email = this.perfil.email;
    this.nomCliente = this.usuario.nombre;
    this.cedCliente = this.usuario.cedula;
    this.telCliene = this.usuario.telefono;
    this.correoCliente = this.usuario.email;
    setTimeout(() => {
      this.calcularCosto();
    }, 500);    
  } 
}

  loadStorage(){
    if (localStorage.getItem('data')) {
      this.lista = JSON.parse( localStorage.getItem('data'));
    }
  }

  calcularCosto(){
    let saldo = 0;
    for (const key in this.lista){
      saldo = this.lista[key].total + saldo;
    }
    this.subtotal = saldo;
    if (this.usrType === 'Distribuidor') {
      this.descuento = (saldo * this.descto) / 100;
      this.liquidacion = saldo - ((saldo * this.descto) / 100);
      if (this.liquidacion === 0) {
        Swal.fire(
          'Tu carrito de compras esta vacío',
          'Selecciona del catálogo los productos que necesitas',
          'success'
        );
        this.router.navigate(['productos']);
      }
    } else {
      this.liquidacion = saldo;
      if (this.liquidacion === 0) {
        Swal.fire(
          'Tu carrito de compras esta vacío',
          'Selecciona del catálogo los productos que necesitas',
          'success'
        );
        this.router.navigate(['productos']);
      }
    }
  }

  deleteItem(item: number){
    Swal.fire({
      title: 'Está seguro?',
      text: 'Se eliminará este producto de la lista!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrarlo!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.lista.splice(item, 1);
        this.prodSvc.updateStorage(this.lista);
        this.calcularCosto();
        Swal.fire(
          'Eliminado!',
          'El producto ya no esta en tu carrito.',
          'success'
        );
      }
    });
  }

  nombreCliente(cliente: string){
    this.nomCliente = cliente;
  }

  cedulaCliente(cedula: string){
    this.cedCliente = cedula;
  }

  ciudadEnvio(ciudad: string){
    this.ciudEnvio = ciudad;
  }

  direccionEnvio(direccion: string){
    this.dirEnvio = direccion;
  }

  telefonoCliente(telefono: string){
    this.telCliene = telefono;
  }

  emailCliente(email:string){
    this.correoCliente = email;
  }

  datosCliente(){
    console.log(this.nomCliente, this.cedCliente, this.telCliene, this.correoCliente, this.dirEnvio, this.ciudEnvio);
    
    if (!this.nomCliente || !this.cedCliente || !this.telCliene || !this.correoCliente || !this.dirEnvio || !this.ciudEnvio) {
      Swal.fire(
        'Error',
        'Verifique que ingresó todos los datos de envío.',
        'error'
      );
      return;
    }
    Swal.fire({
      title: 'Está seguro?',
      text: 'Se va a enviar la solicitud de compra con los productos seleccionados!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, enviar!'
    }).then((result) => {
      if (result.isConfirmed) {
        const fecha = new Date().getTime();
        this.reference = Math.ceil(Math.random() * 987524);
        if (this.distrib) {
          this.compra.cliente = this.idUser;
          this.compra.tipo = this.usrType; 
                   
        }
        if (!this.distrib) {
          this.compra.cliente = 'N/A';
          this.compra.tipo = 'Cliente';         
        }
        this.compra.nombre = this.nomCliente;
        this.compra.cedula = this.cedCliente;
        this.compra.email = this.correoCliente;
        this.compra.telefono = this.telCliene; 
        this.compra.direccion = this.dirEnvio;
        this.compra.ciudad = this.ciudEnvio;
        this.compra.subtotal = this.subtotal;
        this.compra.descuento = this.descuento;
        this.compra.total = this.liquidacion;        
        this.compra.carrito = this.lista;
        this.compra.refCompra = this.reference;

       // console.log(this.compra);
        this.prodSvc.cargarSolicitudCompra(this.compra);
        this.compra = [];
        localStorage.setItem('data', JSON.stringify(this.compra));
        this.router.navigate([`productos/${this.usrType}`]);
        Swal.fire(
          'Enviado!',
          'Su solicitud de compra fué enviada correctamente.',
          'success'
        ); 
      }
    });
  }

  onClick(){
    this.router.navigate([`productos/${this.usrType}`]);
  }

}
